<template>
  <div class="infoDetailUser detail-employee">
    <div class="avatar">
      <img :src="editEmployee.avatar" alt class="avt-modal" />
    </div>
    <div class="text-center afterAvt">
      <h2 class="nameUser">{{truncate(editEmployee.name,15,'...')}}</h2>
      <p class="department">{{truncate(editEmployee.position,15,'...')}}</p>
    </div>
    <div class="text-left second-box">
      <div class="info-table">
        <span class="label">社員コード</span>
        <span class="value id">{{truncate(editEmployee.employee_code,10,'...')}}</span>
      </div>
      <div class="info-table">
        <span class="label">電話番号</span>
        <span class="value phone">{{truncate(editEmployee.phone,13,'...')}}</span>
      </div>
      <div class="info-table">
        <span class="label">メールアドレス</span>
        <span class="value email">{{truncate(editEmployee.email,20,'...')}}</span>
      </div>
    </div>
    <div class="text-center button-box">
      <button class="btn btn-edit btn-rounder w-100" @click="showModalEdit">
        <i class="icon-i-edit"></i>
        <span>編集</span>
      </button>
      <button class="btn btn-second btn-rounder w-100" @click="showModalDelete">削除</button>
      <b-link href="#" @click.prevent="$bvModal.show(`modalUserSettings`)" class="mt-2">ファイル設定</b-link>
    </div>
    <modalEditEmployee />
    <modalDeleteEmployee :idDelete="idDelete"/>
    <modalFileSettings :user="editEmployee"/>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import modalEditEmployee from '@/views/Admin/Company/Employee/Edit'
import modalDeleteEmployee from '@/views/Admin/Company/Employee/Delete'
import modalFileSettings from '@/views/Admin/Company/Employee/FileSettings'
export default {
  name: 'Sidebar_Detail_Employee',
  data () {
    return {
      idDelete: ''
    }
  },
  components: {
    modalEditEmployee,
    modalDeleteEmployee,
    modalFileSettings
  },
  mounted () {
    this.$store.dispatch('adminEmployee/detailEmployee', {id: this.$route.params.employee_id})
  },
  computed: {
    ...mapState({
      detailEmployee: state => state.adminEmployee.detailEmployee,
      editEmployee: state => state.adminEmployee.editEmployee
    })
  },
  methods: {
    showModalEdit () {
      this.$store.dispatch('adminEmployee/detailEmployee', {id: this.$route.params.employee_id})
      this.$root.$emit('bv::show::modal', 'modalEditEmployee', '#modalEditEmployee')
    },
    showModalDelete () {
      this.idDelete = this.$route.params.employee_id
      this.$root.$emit('bv::show::modal', 'modalDeleteEmployee', '#modalDeleteEmployee')
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/stylesheet/user/detail_user.scss';
@import '@/assets/stylesheet/admin/vendor.scss';
</style>



// WEBPACK FOOTER //
// src/components/Admin/Company/Employee/SidebarDetail.vue